module.exports = __webpack_public_path__ + "img/enterprise-main17.65e63d5e.png";